












































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";
import SelectStadium from "@/components/selectstadium.vue";

import Detail from "../manage-record/detail.vue";

@Component({
  components: {
    Detail,
    SelectStadium
  }
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  @Prop() modalTitle!: string;

  @Prop() modalParams!: any;

  dispatchType = "stadium/manageRecordList";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "场馆", dataIndex: "stadium_name" },
    { title: "操作人", dataIndex: "member_name" },
    { title: "类型", scopedSlots: { customRender: "job_type" } },
    { title: "入馆时间", dataIndex: "manage_time" },
    { title: "离馆时间", dataIndex: "end_time" },
    { title: "记录时间", dataIndex: "created_time" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.searchData = { ...this.modalParams };
    this.loadData(
      {
        stadium_id: this.stadiumId,
        ...this.modalParams
      },
      false
    );
  }
}
